<adl-table
  [loading]="isLoading"
  [searchField]="true"
  [tableData]="patients"
  [columnHeader]="columnHeaderPatient"
  [paginationInfo]="patientsPaginated"
  (configChange)="setConfig($event)"
  (rowClick)="patientSelect($event)"
   [tableTitle]="'patients' | transloco"
></adl-table>
